import DefaultArticle from './defaultArticle';
import BranchArticle from './branchArticle';
import HorizontalArticles from './horizontalArticles';
import TeaserArticles from './teaserArticles';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';


function OnePagerArticle({
  articleId,
  articleType,
  hasSliderArticles
}) {
  if (hasSliderArticles) {
    if (articleType === 'event' || articleType === 'report' || articleType === 'pressrelease') {
      return <TeaserArticles articleId={articleId} articleType={articleType} />;
    }

    return <HorizontalArticles articleId={articleId} articleType={articleType} />;
  }

  if (articleType === 'branch'){
    return (
      <I18nextProvider i18n={i18n} >
        <BranchArticle articleId={articleId} />
      </I18nextProvider>
    );

  }

  return <DefaultArticle articleId={articleId} />;
}

OnePagerArticle.propTypes = {
  articleId: React.PropTypes.number,
  articleType: React.PropTypes.string,
  hasSliderArticles: React.PropTypes.bool
};

export default OnePagerArticle;



// WEBPACK FOOTER //
// ./components/articles/onePagerArticle.js